// Design tokens — Contatos (lista).
// Referência: .md/DESIGN_UIUX.md

export const CONTATOS_DESIGN = {
  root: 'flex flex-col h-full min-h-0 w-full bg-[#f4f4f7] text-[#18181b]',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',

  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec] shrink-0',
  headerRow: 'flex flex-wrap items-center gap-2.5 py-3',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b] shrink-0 mr-1.5',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0',
  searchRow: 'flex items-center w-full sm:w-[240px] ml-auto min-w-0',
  searchField:
    'flex items-center gap-2.5 w-full h-10 px-3.5 rounded-lg border border-[#d4d4d8] bg-white transition-colors hover:border-[#b8b8c0] focus-within:border-[#8b5cf6] focus-within:ring-2 focus-within:ring-[#c4b5fd]',
  searchIcon: 'flex-shrink-0 text-[#a1a1aa] hover:text-[#6d28d9] transition-colors',
  searchInput:
    'flex-1 min-w-0 h-auto border-0 bg-transparent p-0 text-[14px] md:text-[14px] text-[#18181b] shadow-none outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 placeholder:text-[#a1a1aa]',

  body: 'flex-1 min-h-0 flex flex-col px-4 md:px-6 lg:px-8 pt-4 pb-6',

  card: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 flex-1 min-h-0 flex flex-col',
  cardFlush: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0',

  label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
  hint: 'mt-[7px] text-[12px] text-[#a1a1aa] leading-[1.5]',
  input:
    'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
  select:
    'w-full box-border h-auto min-h-[44px] px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] font-normal text-[#18181b] shadow-none',

  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed',
  dangerButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#b42318] whitespace-nowrap transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca]',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca]',
  iconButtonOk:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#067647] transition-colors hover:bg-[#ecfdf3] hover:border-[#abefc6]',

  chip: 'inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-[#ede9fe] text-[12px] font-semibold text-[#5b21b6] whitespace-nowrap',

  tableWrap: 'w-full overflow-x-auto overflow-y-auto flex-1 min-h-0',
  tableWrapNoScrollX: 'w-full overflow-x-hidden overflow-y-auto flex-1 min-h-0',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa]',
  tableCell: 'text-[14px] text-[#18181b]',
  tableCellMuted: 'text-[13px] text-[#71717a]',
  tableRow: 'border-b border-[#f0f0f3] last:border-b-0 hover:bg-[#fafafb] cursor-pointer',
  tableHeaderRow: 'border-b border-[#f0f0f3] bg-[#fafafb]',

  emptyState: 'flex flex-col items-center justify-center flex-1 py-16 text-center px-4',
  emptyIcon:
    'mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',

  selectionBar:
    'flex items-center justify-between gap-3 px-[18px] py-3 rounded-[12px] border border-[#ddd6fe] bg-[#ede9fe] mb-3.5',
  selectionCount:
    'flex items-center justify-center w-8 h-8 rounded-lg bg-[#6d28d9] text-white text-[13px] font-bold',
  selectionLabel: 'text-[14px] font-semibold text-[#5b21b6]',

  pagination:
    'shrink-0 border-t border-[#f0f0f3] px-3 sm:px-5 py-3 bg-[#fafafb] flex items-center justify-between gap-3 flex-wrap',
  paginationText: 'text-[13px] text-[#71717a]',

  dialogTitle: 'text-[15px] font-semibold text-[#18181b]',
  dialogDesc: 'text-[13px] text-[#71717a] leading-[1.5]',
  dialogFooter: 'flex justify-end gap-2.5',
};

export default CONTATOS_DESIGN;
